import React from "react";
import Layout from "../../Layout";
import Form from "./form";
import useApi from "Hooks/Upload/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Users(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Upload - ユーザ登録";
  }, []);

  const handleSubmit = ({ name, desc, email, password, userType }) => {
    request({
      method: "POST",
      url: `media/upload/users`,
      data: {
        name: name,
        desc: desc,
        email: email,
        password: password,
        user_type: userType,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/upload/config/user?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };
  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Users);
